import { useState } from "react";
import { motion } from "framer-motion";

const TIER_IMAGES = {
  1: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/5frlurfj_vibrant_energetic_person_in_their_60s_in_a_warm_sunlit_moder.png",
  2: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/qmwxpb7g_An_illustrated_athletic_couple_undergoing_advanced_metabolic.png",
  3: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/lsn146d1_A_sophisticated_wellness_optimization_system_with_interconne.png",
  4: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/mpc2at05_An_illustrated_male_silhouette_integrated_with_DNA_helixes_a.png",
};

export const TierPriorityMap = ({ tiers }) => {
  const [activeTier, setActiveTier] = useState(tiers[0].n);
  const active = tiers.find((tier) => tier.n === activeTier) || tiers[0];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 border-2 border-primary/15 bg-card">
      <div className="lg:col-span-7 p-5 md:p-7 border-b lg:border-b-0 lg:border-r border-border">
        <div className="font-mono text-xs uppercase tracking-[0.16em] text-primary/60 mb-5">Intervention sequence</div>
        <div className="space-y-2">
          {tiers.map((tier, index) => {
            const selected = tier.n === activeTier;
            return (
              <div
                key={tier.n}
                data-testid={`tier-card-${tier.n}`}
                style={{ width: `${100 - index * 8}%`, marginLeft: `${index * 8}%` }}
              >
              <button
                type="button"
                onPointerDown={() => setActiveTier(tier.n)}
                onClick={() => setActiveTier(tier.n)}
                aria-pressed={selected}
                data-testid={`tier-map-button-${tier.n}`}
                className="group relative block h-16 w-full text-left"
              >
                <motion.span
                  animate={{ opacity: selected ? 1 : 0.5 }}
                  className={`absolute inset-0 border transition-colors ${selected ? "border-accent bg-accent" : "border-primary/25 bg-primary"}`}
                />
                <span className="relative z-10 flex h-full items-center justify-between gap-4 px-4 text-white">
                  <span className="font-display text-base font-bold">{tier.name}</span>
                  <span className="font-mono text-xs uppercase tracking-[0.14em]">Tier {tier.n}</span>
                </span>
              </button>
              </div>
            );
          })}
        </div>
      </div>

      <div data-testid={`tier-map-detail-${active.n}`} className="lg:col-span-5 relative min-h-[430px] overflow-hidden">
        <motion.img
          key={TIER_IMAGES[active.n]}
          initial={{ opacity: 0.5 }}
          animate={{ opacity: 1 }}
          src={TIER_IMAGES[active.n]}
          alt={`${active.name} optimization tier visual`}
          data-testid={`tier-map-image-${active.n}`}
          className="absolute inset-0 h-full w-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground via-foreground/5 to-transparent" aria-hidden />
        <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
          <div className="font-mono text-xs uppercase tracking-[0.16em] text-white/70">Tier {active.n}</div>
          <h3 className="mt-2 font-display text-xl md:text-2xl font-bold text-white">{active.name}</h3>
          <p className="mt-2 text-sm text-white/75 leading-relaxed">{active.body}</p>
        </div>
      </div>
    </div>
  );
};